import React, { useEffect, useState } from 'react'
import Leftmenu from '../components/Leftmenu'
import Rightmenu from '../components/Rightmenu'
import Header from '../components/Header'
import FriendCardMain from '../components/FriendCardMain'
import { useOutletContext } from "react-router-dom";
function FindFriend() {
         const { user, token } = useOutletContext();
         const [suggestions, setSuggestions] = useState([]);
    const getsuggestion =()=>{
        fetch('api/find-connections',{
            method:'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }).then((response) => response.json())
        .then((data) => {
          
            setSuggestions(data.data);
        }).catch((error) => {
            console.log(error);
        })
    }
    useEffect(() => {
        getsuggestion();
    },[]);
  return (
    <div>
        <Header />
        <Leftmenu />
        <Rightmenu />

    <div className="main-content right-chat-active">
  <div className="middle-sidebar-bottom">
    <div className="middle-sidebar-left pe-0">
      <div className="row">
        <div className="col-xl-12">
          <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 my-4">
            <div className="card-body d-flex align-items-center p-0">
              <h2 className="fw-700 mb-0 mt-0 font-md text-grey-900">Find Connection</h2>
           
             
            </div>
          </div>
          <div className="row ps-2 pe-2">
            {suggestions.length > 0 && suggestions.map((suggestion) => (
                <FriendCardMain data={suggestion} type={"suggestion"} key={suggestion.id} />
            ))}
  
            

          </div>
        </div>               
      </div>
    </div>
  </div>            
</div>

    </div>
  )
}

export default FindFriend